import type { RichLink } from '../../../domain/RichLink'
import type { RichLinkDTO } from '../../../domain/RichLinkDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

export const mapRichLinkFromApi = (dto: RichLinkDTO): RichLink | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { important, link, name } = dto.fields

  return {
    contentType: ContentModelId.RICH_LINK,
    important,
    link,
    name,
  }
}
